var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReple(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "reple",
    transform: "translate(-1139.156 -417.156)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_11474",
    "data-name": "\\uC0AC\\uAC01\\uD615 11474",
    width: 20,
    height: 20,
    rx: 6,
    transform: "translate(1139.156 417.156)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_16722",
    "data-name": "\\uADF8\\uB8F9 16722",
    transform: "translate(1145.156 423.156)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_38146",
    "data-name": "\\uD328\\uC2A4 38146",
    d: "M1,1.56V5.7A1.669,1.669,0,0,0,2.781,7.224H8.429",
    transform: "translate(-1 -1.56)",
    fill: "none",
    stroke: "#999",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_38147",
    "data-name": "\\uD328\\uC2A4 38147",
    d: "M11.555,9.99l2.539,2.559-2.5,2.519",
    transform: "translate(-6.094 -6.865)",
    fill: "none",
    stroke: "#999",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReple);
export default __webpack_public_path__ + "static/media/reple.e664531dfd1573dacb46e55eadef279e.svg";
export { ForwardRef as ReactComponent };